import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";
import { SharedService } from "src/app/services/sharedService";
import { MultiselectAutocompleteComponent } from "../../multiselect-autocomplete/multiselect-autocomplete.component";
import { CompanyDexieService } from "src/app/services/companyDexie-services/companyDexie.service";
import { BaseComponent } from "../../base.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-search-taxpayer-match-requests',
  templateUrl: './search-taxpayer-match-requests.component.html',
  styleUrls: ['./search-taxpayer-match-requests.component.css']
})
export class SearchTaxpayerMatchRequestsComponent extends BaseComponent implements OnInit, OnDestroy {

  selectedMun = []
  @ViewChild('municipalitySelect', { static: false }) municipalitySelect: MultiselectAutocompleteComponent;
  filterData = {
    municipality: [],
  };
  statuses = ['PENDING', 'MATCHED', 'REJECTED']
  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields: any;
  municipalityChangeSubscription: any
  queryFilter = {};
  filterFields = ["municipality"];
  panelOpenState = true;
  constructor(public categoryService: CategoryService, public entityService: EntityService, public sharedService: SharedService,
    public reportService: ReportService, public companyDexieService: CompanyDexieService, private cdr: ChangeDetectorRef
  ) {
    super()
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
    if (this.municipalityChangeSubscription) this.municipalityChangeSubscription.unsubscribe()
  }

  objectComparisonFunctionId = function (option, value): boolean {
    let sss = value ? option.key === value.key : false
    return sss;
  };

  selectChange = (event: any, field) => {
    this.queryFilter[field] = event.data.map(elem => elem.id)
    if (this.queryFilter[field].length === 0) {
      delete this.queryFilter[field]
    }
  };

  resetFilter() {
    try {
      this.queryFilter = {}
      this.municipalitySelect.resetAll()
      this.onReset.emit()
    } catch (error) {

    }
  }

  advancedSearch() {
    let selData = []
    selData = this.municipalitySelect.selectData.filter(el => el.selected).map(el => el.item.id)
    if (localStorage.getItem('municipality')) {
      if (localStorage.getItem('municipality') == "-1") {
        delete this.queryFilter['municipality']
      } else {
        if (selData.length > 0)
          this.queryFilter['municipality'] = selData
        else
          this.queryFilter['municipality'] = [localStorage.getItem('municipality')]
      }
    } else {
      if (this.municipalitySelect.selectData.length === 0)
        delete this.queryFilter['municipality']
    }
    this.onFilter.emit(this.queryFilter)
    this.panelOpenState = false
  }

  ngOnInit() {

    if (this.statuses.length > 0) {
      this.queryFilter['status'] = this.statuses[0];
      this.cdr.detectChanges();
    }
    this.sharedService.onlineStatus$.subscribe(async status => {
      this.resetFilter()
      this.filterData['municipality'] = null
      if (!status) {
        this.filterData['municipality'] = await this.companyDexieService.getUniqueMunicipalities()
      } else {
        this.sharedService.setMunicipalitiesSubject$.pipe(takeUntil(this.destroy$)).subscribe(municipalities => {
          if (municipalities) {
            this.filterData['municipality'] = municipalities.map((fld) => ({ name: fld.name, id: fld.id }))
            if (localStorage.getItem('municipality'))
              this.selectedMun = this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality'))
          }
        })
      }
    });
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      if (localStorage.getItem('municipality')) {
        this.selectedMun = null;
        if (localStorage.getItem('municipality') !== '-1') {
          this.municipalitySelect.resetAll()
          this.selectedMun = this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality'))
          this.municipalitySelect.setSelectedData(this.selectedMun)
        }
        else {
          this.municipalitySelect.resetAll()
        }
      } else {
        this.municipalitySelect.resetAll()
      }
    })
  }
}
